riot.tag2('bbc-notifications-card-carousel', '<div class="notifications--card-carousel"> <div class="notifications--card-carousel-arrows"> <button onclick="{this.scrollLeft}" class="notifications--card-carousel-arrow" __disabled="{this.scrollProgress <= 0}"><img class="notifications--card-carousel-arrow-svg" riot-src="{this.opts.basePath + \'/svg/arrow_left_black.svg\'}"></button> <button onclick="{this.scrollRight}" class="notifications--card-carousel-arrow" __disabled="{this.scrollProgress >= 1}"><img class="notifications--card-carousel-arrow-svg" riot-src="{this.opts.basePath + \'/svg/arrow_right_black.svg\'}"></button> </div> <div name="container" class="notifications--card-carousel-container" onscroll="{this.scroll}"> <yield></yield> </div> </div> <div class="notifications--card-carousel-scrollbar" name="scrollbar"> <div name="scrollbarProgress" class="notifications--card-carousel-scrollbar-progress" riot-style="width: {this.scrollWidth}%; left: {this.scrollOffset}px;"></div> </div>', '', '', function(opts) {
'use strict';

var _this = this;

var notificationsAnalytics = require('../analytics');

this.scrollWidth = 0;
this.scrollProgress = 0;
this.scrollOffset = 0;

function smoothScroll(element, target) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 250;

    target = Math.round(target);
    duration = Math.round(duration);
    if (duration < 0) {
        return;
    }
    if (duration === 0) {
        element.scrollLeft = target;
        return;
    }

    var startTime = Date.now();
    var endTime = startTime + duration;

    var startLeft = element.scrollLeft;
    var distance = target - startLeft;

    // based on http://en.wikipedia.org/wiki/Smoothstep
    function smoothStep(start, end, point) {
        if (point <= start) {
            return 0;
        }
        if (point >= end) {
            return 1;
        }
        var x = (point - start) / (end - start); // interpolation
        return x * x * ((3 - 2) * x);
    }

    // This is to keep track of where the element's scrollLeft is
    // supposed to be, based on what we're doing
    var previousLeft = element.scrollLeft;

    // This is like a think function from a game loop
    function scrollFrame() {
        if (element.scrollLeft !== previousLeft) {
            return;
        }

        // set the scrollLeft for this frame
        var now = Date.now();
        var point = smoothStep(startTime, endTime, now);
        var frameTop = Math.round(startLeft + distance * point);
        element.scrollLeft = frameTop;

        // check if we're done!
        if (now >= endTime) {
            return;
        }

        // If we were supposed to scroll but didn't, then we
        // probably hit the limit, so consider it done; not
        // interrupted.
        if (element.scrollLeft === previousLeft && element.scrollLeft !== frameTop) {
            return;
        }
        previousLeft = element.scrollLeft;

        // schedule next frame for execution
        setTimeout(scrollFrame, 0);
    }

    // boostrap the animation process
    setTimeout(scrollFrame, 0);
}

this.scroll = function () {
    _this.scrollProgress = _this.container.scrollLeft / (_this.container.scrollWidth - _this.container.clientWidth);

    _this.scrollOffset = (_this.scrollbar.clientWidth - _this.scrollbarProgress.clientWidth) * _this.scrollProgress;
};

var scrollButtonDistance = 266 + 8 * 2; // Card width + padding

this.scrollLeft = function () {
    smoothScroll(_this.container, _this.container.scrollLeft - scrollButtonDistance);
    notificationsAnalytics.log('paginate-left', 'notifications-in-tray-brand');
};

this.scrollRight = function () {
    smoothScroll(_this.container, _this.container.scrollLeft + scrollButtonDistance);
    notificationsAnalytics.log('paginate-right', 'notifications-in-tray-brand');
};

this.on('updated', function () {
    console.log('carousel updated', _this.container.clientWidth, _this.container.scrollWidth);

    // if the view is not visible (drawer closed), clientWidth and scrollWidth would be 0
    if (_this.container.clientWidth + _this.container.scrollWidth === 0) {
        return;
    }

    var scrollWidth = _this.container.clientWidth / _this.container.scrollWidth * 100;
    console.log('carousel new scroll width', scrollWidth);

    if (scrollWidth !== _this.scrollWidth) {
        _this.scroll();
        console.warn('carousel scroll width changed', scrollWidth);
        _this.update({ scrollWidth: scrollWidth });
    }
});
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/components/bbc-notifications-card-carousel.tag
 ** module id = 19
 ** module chunks = 0
 **/